import React, { useContext, useState, useEffect, useRef } from "react";
import Papa from "papaparse";
import "../ProductList.css";
import { useNavigate } from "react-router-dom";
import Slider from "./Silder";
import { Link } from "react-router-dom";
import { CartContext } from "../CartContext";
import VideoPopup from "./VideoPopup";
import { GoMoveToTop } from "react-icons/go";
import { images } from "./ax2";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc
} from "firebase/firestore";
import { MainDb } from "../fireMainStore";
// import { CartContext } from "../CartContext"; // import your CartContext
const Nancy = () => {
  //   const [products, setProducts] = useState([]);
  //   const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [color, setColor] = useState("");
  const [percentage, setPercentage] = useState("");
  const [themeTag, setThemeTag] = useState(""); // e.g. "Christmas"
  const [selectedTags, setSelectedTags] = useState({
    Infant: false,
    Toddler: false,
    Youth: false,
    Sweatshirts: false,
    "Full Zip": false,
    Pants: false,
    Shorts: false,
    "T-Shirts": false,
    Caps: false,
    Activewear: false,
    Outerwear: false,
    "Long Sleeve": false,
    Polos: false,
  });
  const [filterMode, setFilterMode] = useState("AND"); // "AND" or "OR"
  const [sliderValue, setSliderValue] = useState("");
  const itemsPerPage = 12;
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [aspectRatio, setAspectRatio] = useState(75); // default 4:3
  const SIZE_ORDER = [
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "2XL",
    "3XL",
    "4XL",
    "5XL",
    "6XL",
  ];
  const cart = useContext(CartContext); // ✅ access CartContext
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalProduct, setModalProduct] = useState(null);
  const [loadingProduct, setLoadingProduct] = useState(null);
  useEffect(() => {
    if (images.length > 0) {
      const img = new Image();
      img.src = images[0].src;
      img.onload = () => {
        setAspectRatio((img.height / img.width) * 100);
      };
    }
  }, [images]);
  useEffect(() => {
    if (videoRef.current) videoRef.current.play();
  }, []);
// useEffect(() => {
//   const loadTheme = async () => {
//     const ref = doc(MainDb, "settings", "store");
//     const snap = await getDoc(ref);

//     if (snap.exists()) {
//       setThemeTag(snap.data().theme || "");
//     }
//   };

//   loadTheme();
// }, []);
//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         const snapshot = await getDocs(collection(MainDb, "nancy"));
//         const rawData = snapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         const grouped = {};

//         rawData.forEach((item) => {
//           // console.log("Processing item:", item); // Debug log
//           const groupKey = `${item.style}__${item.imageId}`;

//           if (!grouped[groupKey]) {
//             grouped[groupKey] = {
//               groupKey,
//               style: item.style,
//               imageId: item.imageId,
//               title: item.title,
//               description: item.description,
//               basePrice: item.price || 0,
//               tags: Array.isArray(item.tags)
//   ? item.tags
//   : typeof item.tags === "string"
//   ? item.tags.split(",").map(t => t.trim())
//   : [],
//                status: item.status || "", 
//               colors: {},
//               sizeMap: {},
//               selectedColor: "",
//               selectedSize: "",
//             };
//           }

//           // ✅ Correctly use grouped[groupKey] instead of grouped[style]
//           if (item.color) {
//             if (!grouped[groupKey].colors[item.color]) {
//               grouped[groupKey].colors[item.color] = {
//                 name: item.color,
//                 image: item.frontImage || item.variantImage,
//                 backImage: item.backImage,
//                 swatch: item.swatchImage,
//               };
//             }

//            if (item.color && item.size) {
//   if (!grouped[groupKey].sizeMap[item.color]) {
//     grouped[groupKey].sizeMap[item.color] = {};
//   }

//   grouped[groupKey].sizeMap[item.color][item.size] = Number(item.price || 0);
// }
//           }
//         });

//         // Convert sets to arrays
// // Convert sets to arrays and calculate min price
// const finalProducts = Object.values(grouped).map((p) => {
//   const colorsArray = Object.values(p.colors);
//   const firstColor = colorsArray[0]?.name || "";

//   // Calculate minimum price across all colors and sizes
//   let minPrice = Infinity;
//   Object.values(p.sizeMap).forEach((sizeObj) => {
// Object.values(sizeObj).forEach((price) => {
//   const num = Number(price || 0);
//   if (num < minPrice) minPrice = num;
// });
//   });
//   if (minPrice === Infinity) minPrice = p.basePrice;

//   return {
//     ...p,
//     basePrice: minPrice, // set basePrice to minimum
//     colors: colorsArray,
//     sizeMap: p.sizeMap,   // keep object
//     selectedColor: firstColor,
//     selectedSize: "",
//   };
// });

//         setProducts(finalProducts);
//         setFilteredProducts(finalProducts);
//         setLoading(false);
//       } catch (err) {
//         console.error("Error loading main-store:", err);
//         setLoading(false);
//       }
//     };

//     loadData();
//   }, []);
useEffect(() => {
  Papa.parse("/nancy.csv", {
    download: true,
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,

    complete: ({ data }) => {
         console.log("CSV DATA:", data);
      try {
        const grouped = {};

       data.forEach((row) => {

const item = {
  style: row.Style,
  imageId: row.ImageID,
  title: row.Title,
  description: row.Body,
  price: row.Price,
  color: row.Color,
  size: row.Size,
  frontImage: row.frontImage,
  variantImage: row.VariantImage,
  backImage: row.backImage,
  swatchImage: row.ImageCircle,
  tags: row.Tags,
  status: row.Status,
  mainPath: row.mainPath,
};

          const groupKey = `${item.style}__${item.imageId}`;

          if (!grouped[groupKey]) {
            grouped[groupKey] = {
              groupKey,
              style: item.style,
              imageId: item.imageId,
              title: item.title,
              description: item.description,
              basePrice: Number(item.price || 0),
              status: item.status || "",
              tags:
                typeof item.tags === "string"
                  ? item.tags.split(",").map((t) => t.trim())
                  : Array.isArray(item.tags)
                  ? item.tags
                  : [],

              colors: {},
              sizeMap: {},
              selectedColor: "",
              selectedSize: "",
            };
          }

          if (item.color) {
            if (!grouped[groupKey].colors[item.color]) {
              grouped[groupKey].colors[item.color] = {
                name: item.color,
                image: item.frontImage || item.variantImage,
                backImage: item.backImage,
                swatch: item.swatchImage,
                mainPath: item.mainPath || "",
              };
            }

            if (!grouped[groupKey].sizeMap[item.color]) {
              grouped[groupKey].sizeMap[item.color] = {};
            }

            grouped[groupKey].sizeMap[item.color][item.size] =
              Number(item.price || 0);
          }
        });

        const finalProducts = Object.values(grouped).map((p) => {
          const colorsArray = Object.values(p.colors);

          let minPrice = Infinity;

          Object.values(p.sizeMap).forEach((sizes) => {
            Object.values(sizes).forEach((price) => {
              if (price < minPrice) minPrice = price;
            });
          });

          if (minPrice === Infinity)
            minPrice = Number(p.basePrice || 0);

          return {
            ...p,
            colors: colorsArray,
            sizeMap: p.sizeMap,
            basePrice: minPrice,
            selectedColor: colorsArray[0]?.name || "",
            selectedSize: "",
          };
        });

        setProducts(finalProducts);
        setFilteredProducts(finalProducts);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(err.message);
        setLoading(false);
      }
    },

    error: (err) => {
      console.error(err);
      setError(err.message);
      setLoading(false);
    },
  });
}, []);
useEffect(() => {
  let result = [...products];

  // 🔎 SEARCH
  if (searchTerm.trim() !== "") {
    const lowerSearch = searchTerm.toLowerCase();

    result = result.filter((product) => {
      const inTitle = product.title?.toLowerCase().includes(lowerSearch);
      const inDescription = product.description
        ?.toLowerCase()
        .includes(lowerSearch);

      const tagsArray = Array.isArray(product.tags)
        ? product.tags
        : typeof product.tags === "string"
        ? product.tags.split(",").map((t) => t.trim())
        : [];

      const inTags = tagsArray.some((tag) =>
        tag.toLowerCase().includes(lowerSearch)
      );

      return inTitle || inDescription || inTags;
    });
  }

  // 🏷 TAG FILTER
  const activeTags = Object.keys(selectedTags).filter(
    (tag) => selectedTags[tag]
  );

  if (activeTags.length > 0) {
    result = result.filter((product) => {
      if (!product.tags) return false;

      if (filterMode === "AND") {
        return activeTags.every((tag) => product.tags.includes(tag));
      } else {
        return activeTags.some((tag) => product.tags.includes(tag));
      }
    });
  }
result.sort((a, b) => {
  const priceA = Number(a.basePrice) + 5;
  const priceB = Number(b.basePrice) + 5;

  // ✅ 1. If slider is being used → ONLY use price logic (ignore theme completely)
  if (sliderValue !== "" && sliderValue !== null) {
    const diffA = Math.abs(priceA - sliderValue);
    const diffB = Math.abs(priceB - sliderValue);

    return diffA - diffB; // closest to slider wins
  }

  // ✅ 2. Only apply theme priority if slider is NOT used
  if (themeTag) {
    const aTags = Array.isArray(a.tags)
      ? a.tags
      : typeof a.tags === "string"
      ? a.tags.split(",").map(t => t.trim())
      : [];

    const bTags = Array.isArray(b.tags)
      ? b.tags
      : typeof b.tags === "string"
      ? b.tags.split(",").map(t => t.trim())
      : [];

    const aHasTheme = aTags.some(
      t => t.toLowerCase() === themeTag.toLowerCase()
    );

    const bHasTheme = bTags.some(
      t => t.toLowerCase() === themeTag.toLowerCase()
    );

    if (aHasTheme && !bHasTheme) return -1;
    if (!aHasTheme && bHasTheme) return 1;
  }

  // ✅ 3. Default fallback (high to low)
  return priceB - priceA;
});

  setFilteredProducts(result);
}, [products, searchTerm, selectedTags, filterMode, sliderValue, themeTag]);

useEffect(() => {
  setCurrentPage(1);
}, [searchTerm, selectedTags, filterMode, sliderValue]);
  const handleColorChange = (groupKey, colorName) => {
    setProducts((prev) =>
      prev.map((p) =>
        p.groupKey === groupKey
          ? { ...p, selectedColor: colorName, selectedSize: "" }
          : p,
      ),
    );
  };

  const handleSizeChange = (groupKey, size) => {
    setProducts((prev) =>
      prev.map((p) =>
        p.groupKey === groupKey ? { ...p, selectedSize: size } : p,
      ),
    );
  };
  const handleAddToCart = async (product) => {
    if (!product.selectedSize) {
      alert("Please select a size");
      return;
    }

    const selectedColorObj = product.colors.find(
      (c) => c.name === product.selectedColor,
    );

    // Calculate total price
   const sizePrice =
  product.sizeMap?.[product.selectedColor]?.[product.selectedSize] || 0;

const price = (Number(sizePrice || 0) + 5).toFixed(2);
    const designPrice = 0; // if you have extra art/design charges you can calculate here
    const total = (parseFloat(price) + parseFloat(designPrice)).toFixed(2);
const cartId = `${product.groupKey}_${product.selectedColor}_${product.selectedSize}`;
    // Call CartContext addOneToCart similar to your Cart component
    cart.addOneToCart(
      cartId, // id
      total, // total price
      product.selectedSize, // size
      product.selectedColor, // color
      product.title, // name
      selectedColorObj?.image, // front image
      null, // thumImage
      null, // thumId
      selectedColorObj?.backImage, // back image
      null, // rating
      product.variantGrams || 0, // weight
      designPrice.toFixed(2), // design cost
      product.selectedColor, // colorName4API
      0, // SalePrice
      null,
      null,
      null,
      null,
      null,
      selectedColorObj?.mainPath, // imageSize1-4, uploadedImage, thumFile
    );

    alert("Added to cart!");
  };

  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = filteredProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct,
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleTagChange = (e) => {
    setSelectedTags((prevTags) => ({
      ...prevTags,
      [e.target.name]: e.target.checked,
    }));
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  if (loading) return <span className="loader"></span>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  return (
    <>
      <div id="top"></div>
      <div className="product-list-container" id="product-container">
        <VideoPopup />
        <div className="sidebar">
          <div className="sidebar-content">
            <div
              className="slider-container"
              style={{
                maxWidth: 250,
                width: "100%",
                position: "relative",
                paddingTop: `${aspectRatio}%`,
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                }}
              >
                <Slider width="100%" height="100%" />
              </div>
            </div>

            <div className="search-box">
              <h6 style={{ marginTop: -10, marginLeft: 5 }}>Categories</h6>
              <input
                type="text"
                value={searchTerm}
                // style={{ fontSize: 8 }}
                onChange={handleSearchChange}
                placeholder="Search by name..."
              />
            </div>

            <div className="checkbox-filters">
              {Object.keys(selectedTags).map((tag) => (
                <label key={tag}>
                  <input
                    type="checkbox"
                    name={tag}
                    checked={selectedTags[tag]}
                    onChange={handleTagChange}
                  />
                  {tag}
                </label>
              ))}
              <hr style={{ marginTop: 10, marginBottom: 5 }} />
              <div className="filter-mode-toggle">
                <label>
                  <input
                    type="radio"
                    name="filterMode"
                    value="AND"
                    checked={filterMode === "AND"}
                    onChange={(e) => setFilterMode(e.target.value)}
                  />
                  Match all
                </label>
                <label>
                  <input
                    type="radio"
                    name="filterMode"
                    value="OR"
                    checked={filterMode === "OR"}
                    onChange={(e) => setFilterMode(e.target.value)}
                  />
                  Match any
                </label>
              </div>
            </div>
          </div>

          <hr style={{ marginTop: -20, marginBottom: 0 }} />

          <div className="slider-container" style={{ textAlign: "center" }}>
            <label htmlFor="price-slider">Sort by Price</label>
            <input
              type="range"
              id="price-slider"
              min="15"
              max="80"
              value={sliderValue || 40}
              onChange={(e) => setSliderValue(Number(e.target.value))}
            />
            <div className="labels" style={{ marginBottom: -15 }}>
              <span className="low">$15</span>
              <span className="high">$80</span>
            </div>
          </div>

          <hr style={{ marginTop: -10, marginBottom: 0 }} />
        </div>
        {/* PRODUCT GRID */}
        <div className="product-grid">
          {currentProducts.length > 0 ? (
            currentProducts.map((product) => {
              const selectedColorObj = product.colors.find(
                (c) => c.name === product.selectedColor,
              );

             const availableSizes = Object.keys(
  product.sizeMap?.[product.selectedColor] || {}
).sort((a, b) => SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b));
const status = (product.status || "").toLowerCase();
const sizePrice =
  product.sizeMap?.[product.selectedColor]?.[product.selectedSize];

let colorOfText = "green";

if (status === "leaving soon") {
  colorOfText = "orange";
} else if (status === "out of stock") {
  colorOfText = "red";
} else if (status === "" || status === "in stock") {
  colorOfText = "green";
}
              return (
                <div key={product.groupKey} className="product-card">
                 
                  <div className="image-container2">
                    
                    <img
                      src={selectedColorObj?.image}
                      onClick={() => setModalProduct(product)}
                      alt={product.title}
                      className="product-image2"
                       title="Click to see details"
                    />
                  </div>

{/* <h6 style={{fontSize:"1.2rem"}}>
{product.selectedSize
  ? `Price: $${(Number(sizePrice || 0) + 5).toFixed(2)}`
  : `Price from: $${(Number(product.basePrice || 0) + 5).toFixed(2)}`
}
</h6> */}
                  {/* Color selector */}
                  <div style={{ display: "flex", gap: 8, marginBottom: 12 ,marginTop:20}}>
                    {product.colors.map((color, index) => (
                      <div
                        key={index}
                        onClick={() =>
                          handleColorChange(product.groupKey, color.name)
                        }
                        title={color.name}
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          cursor: "pointer",
                          backgroundImage: `url(${color.swatch})`,
                          backgroundSize: "cover",
                          border:
                            product.selectedColor === color.name
                              ? "2px solid black"
                              : "1px solid #ccc",
                        }}
                      />
                    ))}
                  </div>

                  {/* Size dropdown */}
                  <select
                    className="fixed-size-dropdown"
                    value={product.selectedSize}
                    onChange={(e) =>
                      handleSizeChange(product.groupKey, e.target.value)
                    }
                  >
                    <option value="">Select Size</option>
                    {availableSizes.map((size, i) => (
                      <option key={i} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>

                  {/* Add/Remove button */}
                  {/* <div className="custom-card-actions">
                    {cart.getProductQuantity(`${product.groupKey}_${product.selectedColor}_${product.selectedSize}`) > 0 ? (
                      <button
                        className="neu-button"
                        style={{ color: "white", backgroundColor: "red" }}
                        onClick={() => cart.removeOneFromCart(`${product.groupKey}_${product.selectedColor}_${product.selectedSize}`)}
                      >
                        Remove
                      </button>
                    ) : (
                      <button
                        className="neu-button2"
                        style={{width:130, height:34, fontWeight:500, marginTop:-7,  border: "none",fontSize:14}}
                        onClick={async () => {
                          setLoadingProduct(product.style);
                          await handleAddToCart(product);
                          setLoadingProduct(null);
                        }}
                        disabled={loadingProduct === product.style}
                      >
                        {loadingProduct === product.style ? (
                          <img
                            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925320/my_uploads/zjmtwr2oulwbgravb759.gif"
                            alt="Adding..."
                            style={{ height: "40px" }}
                          />
                        ) : (
                          "Add To Cart"
                        )}
                      </button>
                     
                    )}
                   
                  </div> */}
{/* <p
  style={{
    color: "white",
    background: colorOfText,
    fontSize: 11,
    padding: "3px 8px",
    borderRadius: 6,
    display: "inline-block",
    marginTop: 5
  }}
>
  {product.status || "In Stock"}

</p> */}


                </div>
              );
            })
          ) : (
            <div style={{ textAlign: "center", width: "100%" }}>
              {/* <p>No products found</p> */}
              <img
                style={{ width: 200, marginTop: 10 }}
                src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925292/my_uploads/wyd702qpywbgad4p7xqk.jpg"
                alt="No products found"
              />
            </div>
          )}
        </div>
      </div>

      {/* MODAL */}
      {modalProduct && (
        <div className="modal-overlay"  onClick={() => setModalProduct(null)}>
          <div className="modal-content" 
          style={{
              backgroundImage: "url('../images/Picture1.png')",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
        }}
          onClick={(e) => e.stopPropagation()}>
         <button
  style={{
    justifyItems: "center",
    marginBottom: 10,
    width: "100%",
    height: 55,
    fontSize: "clamp(14px, 2vw, 20px)", // responsive font
    textAlign: "center",
    fontWeight: "bold",
    alignContent: "center"
  }}
  className="button-85"
>
  {modalProduct.title}
</button>
            {/* <h2>{modalProduct.title}</h2> */}

            {/* MAIN LARGE IMAGE */}
            <div className="modal-main-image">
              <img
              style={{   mixBlendMode: "multiply" }}
                src={
                  modalProduct.colors.find(
                    (c) => c.name === modalProduct.selectedColor,
                  )?.image
                }
                alt={modalProduct.title}
              />
            </div>

            {/* DESCRIPTION */}
            <div
              className="modal-description"
              dangerouslySetInnerHTML={{ __html: modalProduct.description }}
            />

            <button
              className="neu-button"
              onClick={() => setModalProduct(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="pagination">
        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        >
          <img
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925250/my_uploads/o7m7damek0k2zanyyhcb.png"
            style={{ maxWidth: 35, marginRight: -50 }}
            alt="First"
          />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <img src="/left-arrow.png" style={{ maxWidth: 35 }} alt="Prev" />
        </button>

        <span style={{ marginLeft: -10 }}>
          Page {currentPage} of {totalPages}
        </span>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <img
            src="/right-arrow.png"
            style={{ maxWidth: 35, marginLeft: -15 }}
            alt="Next"
          />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          <img
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925251/my_uploads/ocislq4muj6wqc5aks2k.png"
            style={{ maxWidth: 35, marginLeft: -50 }}
            alt="Last"
          />
        </button>
      </div>

      <div>
        <a href="#top" style={{ textDecoration: "none", color: "black" }}>
          <p style={{ fontSize: "30px", fontWeight: "bold" }}>
            <GoMoveToTop />
          </p>
          <p style={{ marginTop: -25 }}>Top</p>
        </a>
      </div>
    </>
  );
};

export default Nancy;
